module.exports = __webpack_public_path__ + "img/homework.6df1b8d9.png";